module.exports = __webpack_public_path__ + "img/02-pension-client.ec1a8c92.png";